import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Checkout from './pages/Checkout';
import DashboardLayout from './components/DashboardLayout';
import Dashboard from './pages/Dashboard';
import Contacts from './pages/Contacts';
import Upload from './pages/Upload';
import { CampaignsList, CampaignDetail } from './pages/Campaigns';
import Templates from './pages/Templates';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import { CompareHub, ComparePage } from './pages/Compare';
import Help from './pages/Help';
import HelpArticle from './pages/HelpArticle';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import { AdminHelpList, AdminHelpEditor } from './pages/AdminHelp';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { Toaster } from './components/ui/sonner';
import { AuthProvider, RequireAuth } from './context/AuthContext';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/compare" element={<CompareHub />} />
            <Route path="/compare/:competitor" element={<ComparePage />} />
            <Route path="/help" element={<Help />} />
            <Route path="/help/:slug" element={<HelpArticle />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/tos" element={<Terms />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/app" element={<RequireAuth><DashboardLayout /></RequireAuth>}>
              <Route index element={<Dashboard />} />
              <Route path="contacts" element={<Contacts />} />
              <Route path="upload" element={<Upload />} />
              <Route path="campaigns" element={<CampaignsList />} />
              <Route path="campaigns/:id" element={<CampaignDetail />} />
              <Route path="templates" element={<Templates />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="settings" element={<Settings />} />
              <Route path="admin/help" element={<AdminHelpList />} />
              <Route path="admin/help/:id" element={<AdminHelpEditor />} />
            </Route>
          </Routes>
          <Footer />
          <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: '#111110', color: '#f5f2ea', border: '1px solid #3a2f18' } }} />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
